import React from 'react';
import BaseClass from '@/pages/BaseClass';

import login from '@/pages/login/login';
import register from '@/pages/login/register';
import findPwd from '@/pages/login/findPwd';
import studyGuide from '@/pages/studyGuide';
import researchLearningList from '@/pages/researchLearning/list';
import researchLearningDetail from '@/pages/researchLearning/detail';
import generalTechnologyList from '@/pages/generalTechnology/list';
import generalTechnologyDetail from '@/pages/generalTechnology/detail';
import userIndex from '@/pages/user/index';
import order from '@/pages/order';

import player from '@/pages/user/study/player';
import aiReport from '@/pages/user/study/aiReport';
import report1 from '@/pages/user/study/report1';
import report2 from '@/pages/user/study/report2';
import reportPreview1 from '@/pages/user/study/reportPreview1';
import reportPreview2 from '@/pages/user/study/reportPreview2';

import '@/assets/css/style.css';
import '@/assets/css/font-awesome.min.css';

import {Route, Switch,} from 'react-router-dom';

import {CommonValue, authUrl, httpPost, message, scrollTop,} from '@/utils/tools';
import Foot from "../components/Foot";

export default class App extends BaseClass {
    constructor(props) {
        super(props);

        this.state = {
            'navIndex': 0,
            'showHead': true,
            'showFoot': true,
            'hasLogin': true,
            'isLoading': false,
            'userInfo': CommonValue.get('user_info') || {},
            'toastScope': {
                'show': false,
                'type': 'error',
                'message': '',
            },
        };

        global.setRootState = this.setRootState.bind(this);
        global.getRootState = this.getRootState.bind(this);
    }

    componentDidMount() {
        this.navIndexInit(this.props.location.pathname);
        this.props.history.listen(event => {
            this.navIndexInit(event.pathname);
            scrollTop();
        });
        /*
        window.addEventListener('hashchange',(event)=>{
        });
        */
    }

    navIndexInit(hash) {
        /*
        let url = window.location.href;
        let hash = url.split('#').pop();
        */

        let navIndex = -1;

        if (hash.indexOf('/studyGuide') === 0) {
            navIndex = 0;
        } else if (hash.indexOf('/researchLearning') === 0) {
            navIndex = 1;
        } else if (hash.indexOf('/generalTechnology') === 0) {
            navIndex = 2;
        } else if (hash.indexOf('/userCenter') === 0) {
            navIndex = 3;
        }

        this.setState({navIndex});

        if (hash.indexOf('/player') === 0) {
            this.setState({
                'showHead': false,
            });
        } else {
            if (!this.state.showHead)
                this.setState({
                    'showHead': true,
                });
        }

        if (hash.indexOf('/player') === 0) {
            this.setState({
                'showFoot': false,
            });
        } else {
            if (!this.state.showFoot)
                this.setState({
                    'showFoot': true,
                });
        }
    }

    setRootState(data) {
        return new Promise((resolve, reject) => {
            for (let i in data) {
                if (this.state[i] === undefined) {
                    delete (data[i]);
                }
            }

            this.setState(data, resolve);
        });
    }

    getRootState(key) {
        return this.state[key];
    }

    logout() {
        if (window.confirm('确认要退出吗?')) {
            CommonValue.set('token', '');
            this.setState({
                'hasLogin': false,
            });

            let url = authUrl('/api/logout');
            httpPost(url, "", 'POST', {
                'rawResponse': true,
            }).then(data => {
                    message('退出成功', 'success');
                    this.props.history.push('/login');
                });
        }
    }

    render() {
        return (
            <>
                {this.state.showHead && (
                    <div className="head">
                        <div className="body">
                            <div className="logo">
                                <h1>
                                    <a href="javascript:;">
                                        创新工坊
                                    </a>
                                </h1>
                                <h2>
                                    中学生在线研究性学习一站式服务平台
                                </h2>
                            </div>
                            <div className="nav">
                                <ul>
                                    <li><a href="javascript:;" onClick={() => window.open('/studyGuide', '_blank')}
                                           className={0 == this.state.navIndex ? 'now' : ''}> 学习指导 </a></li>
                                    <li><a href="javascript:;"
                                           onClick={() => window.open('/researchLearning', '_blank')}
                                           className={1 == this.state.navIndex ? 'now' : ''}> 研究性学习 </a></li>
                                    <li><a href="javascript:;"
                                           onClick={() => window.open('/generalTechnology', '_blank')}
                                           className={2 == this.state.navIndex ? 'now' : ''}> 通用技术 </a></li>
                                    <li><a href="javascript:;" onClick={() => window.open('/user', '_blank')}
                                           className={3 == this.state.navIndex ? 'now' : ''}> 个人中心 </a></li>
                                    {!this.state.hasLogin ? (
                                        <li><a href="javascript:;" onClick={() => window.open('/login', '_blank')}
                                               className={4 == this.state.navIndex ? 'now' : ''}> 登录 </a></li>
                                    ) : (
                                        <li><a href="javascript:;" onClick={() => this.logout()}
                                               className={4 == this.state.navIndex ? 'now' : ''}> 退出登录 </a></li>
                                    )}
                                </ul>
                            </div>
                            <div className="clear"></div>
                        </div>
                    </div>
                )}
                <Switch>
                    <Route exact path="/" component={login}/>
                    <Route path="/login" component={login}/>
                    <Route path="/register" component={register}/>
                    <Route path="/findPwd" component={findPwd}/>
                    <Route path="/studyGuide" component={studyGuide}/>
                    <Route exact path="/researchLearning" component={researchLearningList}/>
                    <Route path="/researchLearning/:id" component={researchLearningDetail}/>
                    <Route exact path="/generalTechnology" component={generalTechnologyList}/>
                    <Route path="/generalTechnology/:id" component={generalTechnologyDetail}/>
                    <Route path="/user/study/aiReport" component={aiReport}/>
                    <Route path="/user" component={userIndex}/>
                    <Route path="/order" component={order}/>
                    <Route path="/player/:id" component={player}/>
                    <Route path="/report1/:id" component={report1}/>
                    <Route path="/report2/:id" component={report2}/>
                    <Route path="/reportPreview1/:id" component={reportPreview1}/>
                    <Route path="/reportPreview2/:id" component={reportPreview2}/>
                </Switch>
                {this.state.showFoot && (
                    <Foot></Foot>
                )}
                <div className="c-mask" style={{'display': this.state.isLoading ? 'block' : 'none'}}></div>
                <div className="c-modal" style={{'display': this.state.isLoading ? 'flex' : 'none'}}>
                    <div className="c-loading">
                        <img src={require('@/assets/images/loading.svg')}/>
                    </div>
                </div>
                <div className={["c-toast", this.state.toastScope.type].join(' ')}
                     style={{'display': this.state.toastScope.show ? 'block' : 'none'}}>
                    <span>{this.state.toastScope.message}</span>
                </div>
            </>
        );
    }
};


